import { Clickable } from '@ahmdigital/ui';
import styled, { css } from 'styled-components';

export const ScrollTopFixed = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 75vh;
`;

export const ScrollTopText = styled.span`
  text-underline-offset: 0.2rem;
`;

export const ScrollTop = styled(Clickable)`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey50};
  color: ${({ theme }) => theme.colors.grey50};
  filter: drop-shadow(${({ theme }) => theme.colors.shadow10} 0.2rem 0.2rem 0.2rem);
  float: right;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: 0 1rem 0.5rem 0;
  padding: 0.25rem 0.8rem 0.8rem 0.25rem;
  position: sticky;
  top: 90vh;
  z-index: ${({ theme }) => theme.zIndices.overlay};

  &:focus {
    outline-offset: 0;
  }

  ${({ theme }) => css`
    ${theme.mediaQueries.above(theme.media.md)} {
      background: none;
      border: none;
      filter: none;
      padding: 0 0.5rem 0 0;
      margin: 0 2.5rem 0.5rem 0;
      top: 50vh;

      &:hover {
        ${ScrollTopText} {
            background: ${theme.colors.grey50};
            color: ${theme.colors.white};
            text-decoration: none;
          }
        }
      }
    }
  `}
`;
